import { createElementVNode as _createElementVNode, vModelText as _vModelText, normalizeClass as _normalizeClass, withDirectives as _withDirectives, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "modal-wrapper" }
const _hoisted_2 = { class: "input-row" }
const _hoisted_3 = { class: "input-wr" }
const _hoisted_4 = {
  key: 0,
  class: "error-hint"
}
const _hoisted_5 = { class: "controls" }
const _hoisted_6 = {
  key: 1,
  class: "spiner-wr"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createBlock($setup["Modal"], {
    isOpen: $props.isOpen,
    onClose: $setup.close
  }, {
    content: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _cache[5] || (_cache[5] = _createElementVNode("div", { class: "modal-title" }, "Share Map", -1)),
        _createElementVNode("form", {
          class: "default-form",
          onSubmit: _cache[2] || (_cache[2] = _withModifiers(() => {}, ["prevent"]))
        }, [
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, [
              _cache[3] || (_cache[3] = _createElementVNode("label", { class: "label" }, "Email", -1)),
              _withDirectives(_createElementVNode("input", {
                class: _normalizeClass(["input", { error: $setup.v$.email.$error }]),
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (($setup.form.email) = $event)),
                type: "email",
                placeholder: "Type your email",
                onBlur: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => ($setup.v$.email.$touch && $setup.v$.email.$touch(...args)))
              }, null, 34), [
                [
                  _vModelText,
                  $setup.form.email,
                  void 0,
                  { trim: true }
                ]
              ]),
              ($setup.v$.email.$error)
                ? (_openBlock(), _createElementBlock("div", _hoisted_4, _toDisplayString($setup.v$.email.$errors[0].$message), 1))
                : _createCommentVNode("", true)
            ])
          ])
        ], 32),
        _createElementVNode("div", _hoisted_5, [
          (!$setup.loading)
            ? (_openBlock(), _createElementBlock("button", {
                key: 0,
                class: "button default primary send",
                onClick: $setup.send
              }, "Send"))
            : (_openBlock(), _createElementBlock("div", _hoisted_6, [...(_cache[4] || (_cache[4] = [
                _createElementVNode("div", { class: "spinner spinner-small" }, null, -1)
              ]))]))
        ])
      ])
    ]),
    _: 1
  }, 8, ["isOpen"]))
}